<!-- eslint-disable vue/no-restricted-html-elements -->
<template>
  <div class="country-selector-us">
    <span
      v-if="flags[currentCountry]"
      class="country-selector__icon"
      :title="$variable('store.countryName')"
    >
      <img
        class="icon icon__flag"
        :src="flags[currentCountry]"
      >
    </span>

    <select
      id="country-selector__select"
      class="country-selector__select"
      :aria-label="$string('general.site_footer.select_country')"
      name="country_code"
      @change="handleCountrySelect"
    >
      <option
        v-for="(country, index) of sortedCountryList"
        :key="index"
        :selected="country.name == 'United States'"
        :value="country.name"
        v-html="country.name"
      />
    </select>
  </div>
</template>

<script>

/**
 * Vue: Country selector us (country-selector-us)
 * -----------------------------------------------------------------------------
 * Country selector used for us.dryrobe store.
 *
 * @param {String} currentCountry - Localization country ISO code.
 * @param {Object} flags - Object of country flags.
 * @param {Array} customUsCountryCodes - Array of custom US country codes.
 *
 */

export default {
  name: 'CountrySelectorUs',

  props: {
    currentCountry: {
      type: String,
      default: '',
    },

    flags: {
      type: Object,
      default: () => ({}),
    },

    customUsCountryCodes: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectedCountry: 'US',
      languageCode: 'en',
      currentURL: '',
    }
  },

  computed: {

    /**
     * Sorts country list in alphabetical order
     * @param {Object} - new country list object
     */
    sortedCountryList() {
      if (!this.customUsCountryCodes.length) {
        return [{ handle: 'US', name: this.$string('general.site_footer.default_country_for_us') }]
      }
      const countryListCopy = this.customUsCountryCodes
      return countryListCopy.sort((a, b) => a.name.localeCompare(b.name))
    },

  },

  methods: {

    /**
     * Handle country select event.
     * @param {Object} event - Select event.
     */
    handleCountrySelect(event) {
      const optionValue = event.target.value
      const matchingStore = this.customUsCountryCodes.find(item => item.name === optionValue)

      window.location.href = matchingStore.url
    },
  },
}
</script>

<style lang="scss">
@import './country-selector-us';
</style>
